/** @import components */

import NoResults from "./NoResults";

import Item from "./Item";

/**
 * 
 * @param { products } 
 * 
 * @returns quick search product results
 * 
 */

const Results = ( { products } ) => { const 

    /** @returns found products */

    Collection = ( { items } ) => {

        if ( ! items.length ) return <NoResults />

        return items.map ( ( item, index ) => <Item product={ item.node } key={ index } /> );

    };

    /** @returns component */

    return ( <div className="collection">

        <Collection items={ products } />

    </div> );

}

/** @export Results */
 
export default Results;